import React from "react";
import styled from "styled-components";

const InfoHeader = ({ text, size, smaller, centered, margin }) => (
  <StyledHeader
    smaller={smaller}
    centered={centered}
    margin={margin}
    size={size}
  >
    {text}
  </StyledHeader>
);

export default InfoHeader;

const StyledHeader = styled.div`
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  font-size: ${(props) => (props.smaller ? "18px" : "22px")};
  font-size: ${(props) => {
    switch (props.size) {
      case "tiny":
        return "14px";
      case "smaller":
        return "18px";
      default:
        return "22px";
    }
  }};
  line-height: 24px;
  margin: ${(props) => (props.margin ? "40px 0 20px" : "0 0 20px")};
  color: #666666;
  text-align: ${(props) => (props.centered ? "center" : "left")};
`;
